import axiosInsAcademy from '@/api/axios-ugems-academy';
import { GET_COURSE_BY_ID } from '@/api/master-data/course-catalog/course-catalog';

const UPLOAD_TIMEOUT_MS = Number(process.env.VUE_APP_UPLOAD_TIMEOUT_MS || 300000);

export default {
  // Get all courses for Mitra Enrollment
  getCourses(params) {
    return axiosInsAcademy.get('/tna/partner/courses', { params });
  },

  // Get course detail - using course-catalog API
  getCourseDetail(id) {
    return GET_COURSE_BY_ID(id);
  },

  // Get batches with participants for a course
  getBatches(courseId, params = {}) {
    return axiosInsAcademy.get(`/tna/partner/courses/${courseId}/batches`, { params });
  },

  // Submit participants for a batch (POST)
  submitParticipants(batchId, data) {
    return axiosInsAcademy.post(`/tna/partner/enrollment/${batchId}`, data);
  },

  // Get TNA summary statistics
  getSummary(params) {
    return axiosInsAcademy.get('/tna/partner/summary', { params });
  },

  // Download enrollment template
  downloadTemplate(courseId, params = {}) {
    return axiosInsAcademy.get(`/tna/partner/enrollment/${courseId}/download-template`, {
      params,
      responseType: 'blob'
    });
  },

  downloadGlobalTemplate(params = {}) {
    return axiosInsAcademy.get('/tna/partner/enrollment/bulk/download-template', {
      params,
      responseType: 'blob'
    });
  },

  // Upload enrollment Excel file
  uploadEnrollment(courseId, formData) {
    return axiosInsAcademy.post(`/tna/partner/enrollment/${courseId}/upload-enrollment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: UPLOAD_TIMEOUT_MS
    });
  },

  uploadGlobalEnrollment(formData) {
    return axiosInsAcademy.post('/tna/partner/enrollment/bulk/upload-enrollment', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: UPLOAD_TIMEOUT_MS
    });
  }
};
